module.exports = __webpack_public_path__ + "img/facebook-4.793b810d.svg";